export const DEV_CONSTANTS = {
  SERVER_URL: 'http://127.0.0.1:3001',
  // SERVER_URL: 'https://api.trusted-rental.com.tw',
};